(function (window, document) {
  'use strict';

  if (window.__scrubzProductForm) return;
  window.__scrubzProductForm = true;

  function parseJson(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function initialize($) {
    function initForm($row) {
      var row = $row[0];
      if (!row || row.getAttribute('data-scrubz-initialized') === 'true') return;

      var $form = $row.closest('form');
      if (!$form.length) return;
      row.setAttribute('data-scrubz-initialized', 'true');

      var $button = $form.find('.js_frm_cart.scrubz-add-to-cart');
      var $variantSelect = $form.find('select.product-select_pr');
      var $quantitySelect = $form.find('.scrubz-quantity-select');
      var $buyNowButton = $form.find('.scrubz-buy-now-button');
      var $inventory = $row.find('script[id^="ScrubzInventory"]').first();
      var buyNowSubmitting = false;
      var variantInventory = $inventory.length ? (parseJson($inventory.text(), {}) || {}) : {};

      function getSelectedVariant() {
        return variantInventory[$variantSelect.val()];
      }

      function updateQuantityOptions() {
        var variant = getSelectedVariant();
        var selectedQuantity = parseInt($quantitySelect.val(), 10) || 1;
        var isTracked = variant && variant.inventory_management !== null && variant.inventory_management !== '';
        var inventory = variant ? parseInt(variant.inventory_quantity, 10) : 0;
        var maxQuantity = isTracked ? Math.min(10, Math.max(0, inventory)) : 10;

        $quantitySelect.empty();
        for (var quantity = 1; quantity <= maxQuantity; quantity++) {
          $quantitySelect.append($('<option>', { value: quantity, text: quantity }));
        }
        var canAddToCart = selectedVariantCanBeAdded();
        $quantitySelect.prop('disabled', !canAddToCart);
        $quantitySelect.val(Math.min(selectedQuantity, maxQuantity));
        $button.prop('disabled', !canAddToCart).toggleClass('disabled', !canAddToCart);
        updateBuyNowButton(canAddToCart);
      }

      function selectedVariantCanBeAdded() {
        var variant = getSelectedVariant();
        if (!variant || !variant.available) return false;
        return !(variant.inventory_management !== null && variant.inventory_management !== '' && parseInt(variant.inventory_quantity, 10) <= 0);
      }

      function updateBuyNowButton(canAddToCart) {
        $buyNowButton.prop('disabled', !canAddToCart || buyNowSubmitting);
      }

      updateQuantityOptions();

      $form.find('.swatch').each(function() {
        var $swatchGroup = $(this);
        $swatchGroup.on('click.scrubz', '.swatches-select > .nt-swatch', function() {
          window.setTimeout(updateQuantityOptions, 0);
        });
      });

      $variantSelect.on('change', updateQuantityOptions);

      $button.on('click', function(event) {
        if (!$variantSelect.val() || !selectedVariantCanBeAdded()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      });

      $buyNowButton.on('click', function(event) {
        event.preventDefault();
        if (buyNowSubmitting) return;

        if (!$variantSelect.val() || !selectedVariantCanBeAdded()) {
          event.stopImmediatePropagation();
          return;
        }

        var productForm = $form[0];
        var returnToField = productForm.querySelector('input[name="return_to"]');
        if (!returnToField) {
          returnToField = document.createElement('input');
          returnToField.type = 'hidden';
          returnToField.name = 'return_to';
          productForm.appendChild(returnToField);
        }
        returnToField.value = '/checkout';
        buyNowSubmitting = true;
        updateBuyNowButton(selectedVariantCanBeAdded());
        window.HTMLFormElement.prototype.submit.call(productForm);
      });
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.scrubz-atc-row'), function (row) {
        initForm($(row));
      });
    }

    initAll();

    // Fires once the quick view markup is in the DOM and before the theme runs
    // geckoShopify.Ntproduct_switch, matching the product page start-up order.
    $(document).off('mfpOpen.scrubzProductForm').on('mfpOpen.scrubzProductForm', function () {
      initAll();
      window.setTimeout(initAll, 0);
    });
  }

  function waitForThemeJQuery(attempt) {
    var themeJQuery = window.jQuery_T4NT;
    if (themeJQuery) {
      themeJQuery(function ($) { initialize($); });
      return;
    }
    if (attempt < 60) window.setTimeout(function () { waitForThemeJQuery(attempt + 1); }, 50);
  }

  waitForThemeJQuery(0);
})(window, document);
